$(function () {
    $('.multiSelect').multiSelect();
});

// NAVBAR Transition
const body = document.body;
let lastScroll = 0;

window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
        body.classList.remove('scrolldown');
    }
    if (currentScroll > lastScroll && !body.classList.contains("scrolldown")) {
        body.classList.remove('scrollup');
        body.classList.add('scrolldown');
    }
    if (currentScroll < lastScroll && !body.classList.contains("scrolldown")) {
        body.classList.add('scrollup');
        body.classList.remove('scrolldown');
    }

    lastScroll = currentScroll;
});


// Page Refresh
window.addEventListener('load', function () {
    window.scrollBy(0, -50);
});


// Owl Carousel
$('.owl-carousel.carousel-one').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

$('.owl-carousel.carousel-two').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 2
        }
    }
})

$('.owl-carousel.carousel-three').owlCarousel({
    loop: true,
    margin: 16,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        }
        ,
        1000: {
            items: 2
        },
        1200: {
            items: 3
        }
    }
})

$('.owl-carousel.carousel-four').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        1000: {
            items: 4
        }
    }
})

$('.owl-carousel.carousel-five').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1000: {
            items: 5
        }
    }
})

var owl = $('.owl-carousel.carousel-six-auto');
owl.owlCarousel({
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 2
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        },
        1200: {
            items: 6
        }
    }
});
$('.play').on('click', function () {
    owl.trigger('play.owl.autoplay', [1000])
})
$('.stop').on('click', function () {
    owl.trigger('stop.owl.autoplay')
})


$('.owl-carousel.carousel-two-center').owlCarousel({
    loop: true,
    center: true,
    margin: 16,
    nav: true,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 1
        },
        1000: {
            items: 2
        },
        2400: {
            items: 4
        }
    }
})

$('.owl-carousel.carousel-four-center').owlCarousel({
    loop: true,
    center: true,
    margin: 16,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        1000: {
            items: 4
        },
        2400: {
            items: 6
        }
    }
})

$('.owl-carousel.carousel-arrow').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        1000: {
            items: 5
        }
    }
})

$('.owl-carousel.carousel-one-arrow').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

$('.owl-carousel.carousel-four-arrow').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        800: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
})


















